<template>
<div v-if="view">
	<v-data-table v-if="$vuetify.breakpoint.mdAndUp"
		:headers="headers"
		:items="filteredData"
		loading="true"
		expand
		item-key="name"
		:custom-sort="headerSort"
		:pagination.sync="pagination"
	>

		<template slot="headerCell" slot-scope="props">
			<v-tooltip bottom>
			<span slot="activator">
				{{ props.header.text }}
			</span>
			<span>
				{{ props.header.title }}
			</span>
			</v-tooltip>
		</template>

		<template  slot="items" slot-scope="props">
		<jm-row	:view="view" :entity="props.item"></jm-row>
		</template>
		<template slot="expand" slot-scope="props">
		<v-card flat>
			<v-card-text>Peek-a-boo!</v-card-text>
		</v-card>
		</template>
	</v-data-table>

	<v-data-iterator v-else
	:items="filteredData"
	content-tag="v-layout"
	column
	wrap
	>
		<v-flex
			slot="item"
			slot-scope="props"
			xs12
			sm6
			md4
			lg3
		>
			<jm-row	:view="view" :entity="props.item"></jm-row>
		</v-flex>
	</v-data-iterator>
</div>
</template>

<script>
import Vuex from 'vuex'
import moment from 'moment'
import JmRow from './Row'
import { Entity } from '@/assets/js/JMan/Entity'

export default {
	name: "JmTableView",

	props: {
		entities: Array,
		view: Object
	},

	data () {
		return {
			pagination: {
			}
		}
	},

	watch: {
		view () {
			this.pagination.sortBy = this.view.sortName;
			this.pagination.descending = this.view.sortDescending;
		}
	},

	computed: {
		//...Vuex.mapState({ data: (state) => state.jman.entities }),

		columns () {
			return this.view.visibleProperties();
		},

		headers () {
			return [
				{ sortable: false, value: "" },

				...this.columns.map(col => {
					return {
						text: col.label,
						value: col.name,
						title: col.title
					}
				})
			];
		},

		filteredData () {
			return this.entities;
		}
	},

	methods: {

		headerSort (items, index, isDescending) {

			if (!items || !index) {
				return items;
			}

			const column = this.columns.find(c => c.name == index);

			const nameSort = (model) => {
				return (a, b) => {
					const _a = Entity.propName(a, model);
					const _b = Entity.propName(b, model);

					return _a > _b
						? 1
						: _a < _b
							? -1
							: 0;
				}
			}

			const timestampSort = (model) => {
				return (a, b) => {
					const value = (a, model) => {
						return a[model] === undefined
							? a.computed[model] instanceof Function
								? a.computed[model]()
								: null
							: a[model] instanceof Function
								? a[model]()
								: a[model];
					}
					const _a = moment(value(a, model));
					const _b = moment(value(b, model));

					return _a > _b
						? 1
						: _a < _b
							? -1
							: 0;
				}
			}

			let sortFn = nameSort(column.name);

			if (["departure", "arrival"].includes(column.name)) {
				sortFn = timestampSort(column.name);
			}

			return isDescending
				? items.sort(sortFn).reverse()
				: items.sort(sortFn);
		}

	},

	components: {
		JmRow
	}
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/TableView.vue